import {
  CreateAlbumFnReq,
  CreateAlbumFnRes,
  Album,
  Mapper,
  AlbumDto,
  SharingResultDto,
  SharingResult,
} from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

export class CreateAlbumInteractor {
  private readonly createAlbumFn = httpsCallable<CreateAlbumFnReq, CreateAlbumFnRes>(
    this.functions,
    'createAlbum',
  );

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
    private readonly albumMapper: Mapper<AlbumDto, Album>,
    private readonly sharingResultMapper: Mapper<SharingResultDto, SharingResult>,
  ) {}

  public async execute(data: Omit<CreateAlbumFnReq, 'auth'>): Promise<[Album, SharingResult]> {
    const res = await this.createAlbumFn({
      ...data,
      auth: await this.getAuthDto.execute(),
    });

    return [
      this.albumMapper.map(res.data.album),
      this.sharingResultMapper.map(res.data.sharingResult),
    ];
  }
}
